import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-visible-fields-checkbox',
  templateUrl: './visible-fields-checkbox.component.html',
  styleUrls: ['./visible-fields-checkbox.component.scss'],
})
export class VisibleFieldsCheckboxComponent implements OnInit {
  @Input() visibleFieldsFormGroupName: string = 'visibleFields';
  @Input() fieldName!: string;
  control!: UntypedFormControl;

  constructor(private rootFormGroup: FormGroupDirective) {}

  ngOnInit(): void {
    if (!this.fieldName) {
      throw Error('Attribute "fieldName" is required');
    }
    this.control = this.rootFormGroup.control.get(
      this.visibleFieldsFormGroupName + '.' + this.fieldName
    ) as UntypedFormControl;
  }
}
